export const endPoints = {
  CONTROL_PERMISSIONS: '/v1/auth/company-role/permission',
  GET_ROLES: '/v1/auth/company-role',
  DELETE_ROLES: '/v1/auth/company-role',
  PERMISSION_STATE: '/v1/auth/permission-state',
  PERMISSION_COMPANY_ROLE_STATE: '/v1/auth/company-role/permission-state'
};
